import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Splitter from '../helpers/Splitter'

//students components
const ManagerStudentsManagementContainer = Splitter(() =>
  import('../components/manager/ManagerStudentsManagementContainer')
)
const ManagerStudentsManagement = Splitter(() =>
  import('../components/manager/students/ManagerStudentsManagement')
)
const ManagerViewStudent = Splitter(() =>
  import('../components/manager/students/ManagerViewStudent')
)
const ManagerEditStudent = Splitter(() =>
  import('../components/manager/students/ManagerEditStudent')
)

//teacher components
const ManagerTeachersManagementContainer = Splitter(() =>
  import('../components/manager/ManagerTeachersManagementContainer')
)
const ManagerTeachersManagement = Splitter(() =>
  import('../components/manager/teachers/ManagerTeachersManagement')
)
const ManagerAddTeacher = Splitter(() =>
  import('../components/manager/teachers/ManagerAddTeacher')
)
const ManagerViewTeacher = Splitter(() =>
  import('../components/manager/teachers/ManagerViewTeacher')
)
const ManagerEditTeacher = Splitter(() =>
  import('../components/manager/teachers/ManagerEditTeacher')
)

//schools components
const ManagerSchoolsManagementContainer = Splitter(() =>
  import('../components/manager/ManagerSchoolsManagementContainer')
)
const ManagerSchoolsManagement = Splitter(() =>
  import('../components/manager/schools/ManagerSchoolsManagement')
)
const ManagerAddSchool = Splitter(() =>
  import('../components/manager/schools/ManagerAddSchool')
)
const ManagerViewSchool = Splitter(() =>
  import('../components/manager/schools/ManagerViewSchool')
)
const ManagerEditSchool = Splitter(() =>
  import('../components/manager/schools/ManagerEditSchool')
)
const ManagerAddStudentToSchool = Splitter(() =>
  import('../components/manager/schools/ManagerAddStudentToSchool')
)
const ViewStudentsOfSchool = Splitter(() =>
  import('../components/school/ViewStudentsOfSchool')
)

//supervisors components
const ManagerSupervisorsManagementContainer = Splitter(() =>
  import('../components/manager/ManagerSupervisorsManagementContainer')
)
const ManagerSupervisorsManagement = Splitter(() =>
  import('../components/manager/supervisors/ManagerSupervisorsManagement')
)
const ManagerAddSupervisor = Splitter(() =>
  import('../components/manager/supervisors/ManagerAddSupervisor')
)
const ManagerViewSupervisor = Splitter(() =>
  import('../components/manager/supervisors/ManagerViewSupervisor')
)
const ManagerEditSupervisor = Splitter(() =>
  import('../components/manager/supervisors/ManagerEditSupervisor')
)
const ViewSupervisorStudents = Splitter(() =>
  import('../components/supervisor/ViewSupervisorStudents')
)
const ManagerAddStudentToSupervisor = Splitter(() =>
  import('../components/manager/supervisors/ManagerAddStudentToSupervisor')
)

//apps components
const ManagerAppsManagementContainer = Splitter(() =>
  import('../components/manager/ManagerAppsManagementContainer')
)
const ManagerAppsManagement = Splitter(() =>
  import('../components/manager/apps/ManagerAppsManagement')
)
const ManagerAddApp = Splitter(() =>
  import('../components/manager/apps/ManagerAddApp')
)
const ManagerViewApp = Splitter(() =>
  import('../components/manager/apps/ManagerViewApp')
)
const ManagerEditApp = Splitter(() =>
  import('../components/manager/apps/ManagerEditApp')
)

export const managerTeacherRoutes = (
  <Route path="manager-teachers" component={ManagerTeachersManagementContainer}>
    <IndexRoute component={ManagerTeachersManagement} />
    <Route path="add" component={ManagerAddTeacher} />
    <Route path="view/:teacherId" component={ManagerViewTeacher} />
    <Route path="edit/:teacherId" component={ManagerEditTeacher} />
  </Route>
)

export const managerSchoolRoutes = (
  <Route path="manager-schools" component={ManagerSchoolsManagementContainer}>
    <IndexRoute component={ManagerSchoolsManagement} />
    <Route path="add" component={ManagerAddSchool} />
    <Route path="view/:schoolId" component={ManagerViewSchool} />
    <Route path="edit/:schoolId" component={ManagerEditSchool} />
    <Route path=":schoolId/students" component={ViewStudentsOfSchool} />
    <Route path=":schoolId/students/add" component={ManagerAddStudentToSchool} />
  </Route>
)

export const managerSupervisorRoutes = (
  <Route
    path="manager-supervisors"
    component={ManagerSupervisorsManagementContainer}>
    <IndexRoute component={ManagerSupervisorsManagement} />
    <Route path="add" component={ManagerAddSupervisor} />
    <Route path="view/:supervisorId" component={ManagerViewSupervisor} />
    <Route path="edit/:supervisorId" component={ManagerEditSupervisor} />
    <Route path=":supervisorId/students" component={ViewSupervisorStudents} />
    <Route
      path=":supervisorId/students/add"
      component={ManagerAddStudentToSupervisor}
    />
  </Route>
)

export const managerStudentsRoutes = (
  <Route path="manager-students" component={ManagerStudentsManagementContainer}>
    <IndexRoute component={ManagerStudentsManagement} />
    <Route path="view/:studentId" component={ManagerViewStudent} />
    <Route path="edit/:studentId" component={ManagerEditStudent} />
  </Route>
)

export const managerAppRoutes = (
  <Route path="manager-apps" component={ManagerAppsManagementContainer}>
    <IndexRoute component={ManagerAppsManagement} />
    <Route path="add" component={ManagerAddApp} />
    <Route path="view/:appId" component={ManagerViewApp} />
    <Route path="edit/:appId" component={ManagerEditApp} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/managerRoutes.js